import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
           L 11, 27
           L 11, 72
           L 50, 95
           L 89, 73
           L 89, 28 z"
      />
      <g id="B" transform="translate(37, 31) scale(1.6)">
       
        <path d="M3.448 18.872C3.448 19.704 3.85333 20.4293 
        4.664 21.048C5.47467 21.6667 6.52 21.976 7.8 21.976C9.08 21.976 
        10.0933 21.6667 10.84 21.048C11.5867 20.4293 11.96 19.608 11.96 
        18.584C11.96 17.2827 11.1813 16.2053 9.624 15.352L4.888 12.824C2.15733 
        11.352 0.792 9.25067 0.792 6.52C0.792 4.77067 1.432 3.26667 2.712 2.008C3.992 0.749332 
        5.90133 0.119999 8.44 0.119999C10.1467 0.119999 11.768 0.461332 13.304 1.144C14.84 1.82667 
        15.608 2.63733 15.608 3.576C15.608 3.93867 15.4907 4.35467 15.256 4.824L13.72 7.768L12.6 
        7.416V4.728C12.6 3.768 12.1733 3.01067 11.32 2.456C10.488 1.90133 9.48533 1.624 8.312 
        1.624C7.16 1.624 6.27467 1.96533 5.656 2.648C5.03733 3.33067 4.728 4.10933 4.728 4.984C4.728 6.73333 
        5.51733 8.024 7.096 8.856L11.16 11C14.2533 12.6213 15.8 14.7547 15.8 17.4C15.8 19.4053 15.0427 20.92 
        13.528 21.944C12.0347 22.968 10.136 23.48 7.832 23.48C6.104 23.48 4.44 23.1387 2.84 22.456C1.24 21.7733 0.44 20.9627 0.44 20.024C0.44 19.6613 0.557333 19.2453 0.792 18.776L2.328 15.832L3.448 16.184V18.872Z" fill="currentColor"/>

      </g>
    </g>
  </svg>
);

export default IconLoader;
